import { Directive, ElementRef, booleanAttribute, effect, inject, input } from '@angular/core';

@Directive({
  selector: '[glxyButtonShowProgress]',
  host: {
    class: 'glxy-button-show-progress-host',
    '[attr.aria-busy]': 'showProgress() ? "true" : null',
    '[class.glxy-button-progress-indicator-shown]': 'showProgress()',
  },
})
export class GlxyButtonShowProgressDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;

  readonly showProgress = input(false, {
    alias: 'glxyButtonShowProgress',
    transform: booleanAttribute,
  });

  constructor() {
    effect(() => {
      this.showProgress();
      this.ensureProgressIndicatorContainer();
    });
  }

  private ensureProgressIndicatorContainer(): void {
    const indicator = this.host.querySelector<HTMLElement>('[progressIndicator]');

    if (!indicator) {
      return;
    }

    let container = this.host.querySelector<HTMLElement>('.glxy-button-progress-indicator-container');

    if (!container) {
      container = document.createElement('div');
      container.classList.add('glxy-button-progress-indicator-container');

      const beforeNode =
        this.host.querySelector('.mat-focus-indicator') ?? this.host.querySelector('.mat-mdc-button-touch-target');

      this.host.insertBefore(container, beforeNode ?? null);
    }

    if (indicator.parentElement !== container) {
      container.appendChild(indicator);
    }
  }
}
